import SmallMultiple from "./SmallMultiple/SmallMultipleMain";

const WasserkraftSmallMultipleSize = ({ title, location_key, colors }) => {
  const items = [
        {
            title: "< 30 kW", 
            explanationText: `Kleinstwasserkraftanlagen dieser Leistungsklasse sind oft an kleinen Bächen oder Flüssen installiert und 
            dienen der lokalen Stromversorgung. Sie kommen typischerweise in Einzelgebäuden, Berghütten oder kleinen Betrieben zum Einsatz. 
            Ihr Betrieb hat meist geringe ökologische Eingriffe, aber begrenzte Energieausbeute.`, 
            size_category: "Power_0_30"
          },
          { 
            title: "30-100 kW", 
            explanationText: `Anlagen dieser Größe werden häufig zur Eigenversorgung kleiner Siedlungen oder Gewerbebetriebe genutzt. 
            Sie verbinden eine höhere Effizienz mit relativ geringem Platzbedarf und nutzen bestehende Gewässerstrukturen. 
            Oft handelt es sich um modernisierte historische Standorte.`, 
            size_category: "Power_30_100"  
          },
          { 
            title: "100 kW - 1 MW", 
            explanationText: `Diese Wasserkraftanlagen zählen zur mittleren Leistungsklasse und leisten einen nennenswerten Beitrag zur 
            dezentralen Stromversorgung. Sie kommen sowohl in ländlichen Regionen als auch in kleineren Städten zum Einsatz und sind 
            häufig Teil von regionalen Erzeugungskonzepten.`, 
            size_category: "Power_100_1000"  
          },
          { 
            title: ">= 1 MW", 
            explanationText: `Großwasserkraftanlagen dieser Kategorie liefern kontinuierlich Strom für das öffentliche Netz. Sie nutzen 
            Flüsse mit konstantem Durchfluss oder Speicherseen und zeichnen sich durch eine hohe Auslastung und lange Lebensdauer aus. 
            Ihr Einfluss auf Ökologie und Gewässermorphologie ist stärker und unterliegt strenger Regulierung.`, 
            size_category: "Power_1000"  
          },
    ];
    
  return (
    <>
      <h3 className="text-xl mt-10 mb-2 font-semibold text-center">{title}</h3>
      <div className="flex flex-wrap justify-center gap-4 rounded-lg">
        {items.map(({ size_category, title, explanationText }, index) => (
          <div
            key={index}
            className="text-center flex-1 min-w-[220px] max-w-xs flex flex-col"
            style={{ flexBasis: "220px" }}
          >
            <SmallMultiple
              textData={{
                summary: title,
                popoverText: explanationText,
              }}
              donutSpec={title}
              location_key={location_key}
              energySource={"HP"}
              unit={"MW"}
              smallMultipleType="size"
              LineChartTitle={'Installierte Leistung in MW'}
              category={size_category}
              colors={colors}
            />
          </div>
        ))}
      </div>
    </>
  );
};

export default WasserkraftSmallMultipleSize;
